import { Custom_Data_Mode, OfferFragment } from '@occc/graphql';
import { Operation } from '@occc-app/offerHelpers/types';
import { makeOfferUpdateOperation } from '@occc-app/offerHelpers/operations/makeOfferUpdateOperation';
import { getCustomDataFromFormValuesYup } from '@occc-app/offerHelpers/utils';

import { GameConfigureFormValues, GameOfferCustomData, GameType } from '../../types';

const mapValuesToGameOfferCustomData = (values: GameConfigureFormValues): GameOfferCustomData => {
  const customData: GameOfferCustomData = { version: 1, spinWheelGame: null };

  if (values.gameType === GameType.SPIN_THE_WHEEL && values.spinWheelGameConfig) {
    customData.spinWheelGame = {
      headerText: values.spinWheelGameConfig.headerText
        ? values.spinWheelGameConfig.headerText.trim()
        : null,
      headerTextColor: values.spinWheelGameConfig.headerTextColor || null,
      footerTextColor: values.spinWheelGameConfig.footerTextColor || null,
      borderColor: values.spinWheelGameConfig.borderColor || null,
      backgroundPrimaryColor: values.spinWheelGameConfig.backgroundPrimaryColor || null,
      backgroundSecondaryColor: values.spinWheelGameConfig.backgroundSecondaryColor || null,
      backgroundImage: values.spinWheelGameConfig.backgroundImage || null,
      foregroundImage: values.spinWheelGameConfig.foregroundImage || null,
      buttonColor: values.spinWheelGameConfig.buttonColor || null,
      buttonTextColor: values.spinWheelGameConfig.buttonTextColor || null,
      segments: values.segments.map((segment) => ({
        icon: segment.icon,
        color: segment.color,
      })),
    };
  }

  return customData;
};

export const getCustomDataOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: GameConfigureFormValues,
): Operation[] => {
  if (!offer) {
    return [];
  }
  // Games still use Yup based validation, so we need to use the Yup
  // version of the function here.
  const customData = getCustomDataFromFormValuesYup(values.customData);
  const customDataOperation = makeOfferUpdateOperation(offerId, {
    customData: {
      data: { ...customData, ...mapValuesToGameOfferCustomData(values) },
      mode: Custom_Data_Mode.Replace,
    },
  });

  return [customDataOperation];
};
